module.exports = __webpack_public_path__ + "static/media/sleep.acba0a60.jpg";